import { AfterViewInit, Component, HostBinding, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SidenavMenu } from 'src/app/models/menu-item';
import { MenuRevolution, UserMenuRevolution } from 'src/app/models/menu/menu.model';
import { SidenavCategory } from "src/app/models/SidenavCategory";
import { ThemeService } from 'src/app/nitro/services/theme.service';
import { MenuService } from 'src/app/services/menu.service';
import { SidenavService } from 'src/app/services/sidenav.service';
const project = require('../../../../../package.json');

@Component({
    selector: 'app-sidenav',
    templateUrl: './sidenav.component.html',
    styleUrls: ['./sidenav.component.scss'],
    standalone: false
})
export class SidenavComponent implements OnInit, OnDestroy, AfterViewInit {

  sidenavUserVisible$ = this.themeService.config$.pipe(map((config: any) => config.sidenavUserVisible));

  @Input()
  @HostBinding('class.collapsed')
  collapsed: boolean = false;

  @Input()
  @HostBinding('class.expanded')
  expanded: boolean = false;

  items$: Observable<SidenavCategory[]> | undefined;
  itemsArray: SidenavCategory[] = [];

  itemsRevolution$: Observable<MenuRevolution[]> | undefined;
  itemsArrayRevolution: MenuRevolution[] = [];

  constructor(private readonly router: Router,
              private readonly sidenavService: SidenavService,
              private readonly themeService: ThemeService,        
              private readonly menuService: MenuService,) {
  }

  ngOnInit() {
    // this.items$ = this.sidenavService.items$ .pipe(
    //   map((items: SidenavCategory[]) => this.sidenavService.sortRecursive(items, 'position'))
    // );

    this.itemsRevolution$ = this.sidenavService.itemsRevolution$ .pipe(
      map((items: MenuRevolution[]) => this.sidenavService.itemsRevolution)
    );
  }

  toggleCollapsed() {
    this.sidenavService.toggleCollapsed();
  }

  @HostListener('mouseenter')
  @HostListener('touchenter')
  onMouseEnter() {
    this.sidenavService.setExpanded(true);
  }

  @HostListener('mouseleave')
  @HostListener('touchleave')
  onMouseLeave() {
    this.sidenavService.setExpanded(false);
  }

  ngOnDestroy() {
    this.sidenavService.deleteItems();
    this.sidenavService.deleteItemsRevolution();
  }

  ngAfterViewInit(): void {
    this.menuService.findAllMenuByUser().subscribe({
      next: (v:any) => {
        if (v?.data) {
          if (v.data.isUserActive && v.data.isRoleActive) {
            this.sidenavService.showID = false;
            let userMenu = new UserMenuRevolution(v.data);
            console.log(userMenu);
            if (userMenu) {
              const auxMenusOrder = userMenu.menuItems.sort((a,b) => (a.position ? a.position : 0) - (b.position ? b.position : 0) )
              this.sidenavService.addItemsRevolution(auxMenusOrder);
              this.sidenavService.addCustomReviewRevolution(auxMenusOrder);
            } else {
              this.router.navigate(['./user-not-active']);
            }
          }
          else {
            this.router.navigate(['./user-not-active']);
          }
        } else {
          this.sidenavService.showID = true;
          this.router.navigate(['./not-user-found']);
        }
      },
      error: (error) => {
        this.sidenavService.showID = true;
      }, 
    })
  }

  getVersion(){
    return `Version ${project.version}`
  }
}
